import styled from 'styled-components';

export const CitationBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background-color: var(--allie-color-neutral-20);
  border-radius: 42px;
  font-family: 'Hanken Grotesk', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
  color: var(--allie-color-neutral-80);
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  /* El tamaño base es solo el icono */
  width: fit-content; /* Usar fit-content en lugar de ancho fijo */

  &:hover,
  &:focus-within {
    z-index: 10;
  }

  /* Estilo para el icono de Allie */
  > svg,
  > ion-icon {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    color: var(--allie-color-neutral-80);
    display: block;
    margin: 0 auto;
  }
`;

